export const OAUTH_CONFIG = {
    clientId: "vGze5E92L341AKJHC1z5BPeHqdFuKQ",
    redirectUri: "https://illyako.github.io/my-simple-app/",
    authUrl: "https://login.questrade.com/oauth2/authorize",
    backUrl: "http://localhost:3000",
};
